import { render, staticRenderFns } from "./PrintOrderA4.vue?vue&type=template&id=dd82d1a0&scoped=true"
import script from "./PrintOrderA4.vue?vue&type=script&lang=js"
export * from "./PrintOrderA4.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderA4.vue?vue&type=style&index=0&id=dd82d1a0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd82d1a0",
  null
  
)

export default component.exports